import api from "../../../shared/services/api";

// Campanhas
export async function loadCampanhasService() {
    const res = await api.get("/campanhas");
    return res.data;
}

export async function createCampanhaService(data) {
    const res = await api.post("/campanhas", data);
    return res.data;
}

export async function updateCampanhaService(id, data) {
    const res = await api.put(`/campanhas/${id}`, data);
    return res.data;
}

export async function toggleCampanhaService(id, ativa) {
    const res = await api.put(`/campanhas/${id}/ativar`, { ativa });
    return res.data;
}

export async function deleteCampanhaService(id) {
    const res = await api.delete(`/campanhas/${id}/delete-total`);
    return res.data;
}

// Grupos da campanha
export async function loadGruposCampanhaService(campanhaId) {
    const res = await api.get(`/campanhas/${campanhaId}/grupos`);
    return res.data;
}

// Detalhes da campanha
export async function loadCampanhaDetalheService(campanhaId) {
    const res = await api.get(`/campanhas/${campanhaId}/detalhe`);
    return res.data;
}

// Grupos disponíveis para importação (WA groups - não vinculados)
export async function loadGruposDisponiveisService(campanhaId, sessionName) {
    const res = await api.get(`/campanhas/${campanhaId}/grupos-disponiveis`, { params: { sessionName } });
    return res.data;
}

export async function vincularGruposService(campanhaId, grupos, sessionName) {
    const res = await api.post(`/campanhas/${campanhaId}/grupos`, { grupos, sessionName });
    return res.data;
}

export async function criarGrupoWAService(campanhaId, data) {
    const res = await api.post(`/campanhas/${campanhaId}/criar-grupo`, data);
    return res.data;
}

export async function editarGruposMassaService(campanhaId, data) {
    const res = await api.post(`/campanhas/${campanhaId}/editar-grupos-massa`, data);
    return res.data;
}

export async function revalidarMembrosService(campanhaId, sessionName) {
    const res = await api.post(`/campanhas/${campanhaId}/revalidar-membros`, { sessionName });
    return res.data;
}

export async function adicionarAdminService(campanhaId, numero) {
    const res = await api.post(`/campanhas/${campanhaId}/adicionar-admin`, { numero });
    return res.data;
}

export async function loadLogsService(campanhaId) {
    const res = await api.get(`/campanhas/${campanhaId}/logs`);
    return res.data;
}

export async function desvincularGrupoService(campanhaId, grupoId) {
    const res = await api.delete(`/campanhas/${campanhaId}/grupos/${grupoId}`);
    return res.data;
}

export async function sincronizarMembrosService(campanhaId) {
    const res = await api.post(`/campanhas/${campanhaId}/sincronizar-membros`);
    return res.data;
}

// Subsessões (envio multi-sessão com rotação)
export async function loadCampanhaSessoesService(campanhaId) {
    const res = await api.get(`/campanhas/${campanhaId}/sessoes`);
    return res.data;
}

export async function salvarCampanhaSessoesService(campanhaId, sessoes) {
    const res = await api.post(`/campanhas/${campanhaId}/sessoes`, { sessoes });
    return res.data;
}

export async function removerCampanhaSessaoService(campanhaId, sessionName) {
    const res = await api.delete(`/campanhas/${campanhaId}/sessoes/${encodeURIComponent(sessionName)}`);
    return res.data;
}

export async function prepararSessoesService(campanhaId) {
    const res = await api.post(`/campanhas/${campanhaId}/preparar-sessoes`);
    return res.data;
}

// Mensagens
export async function loadMensagensService(campanhaId) {
    const res = await api.get(`/mensagens/${campanhaId}/mensagens`);
    return res.data;
}

export async function createMensagemService(data) {
    const res = await api.post("/mensagens", data);
    return res.data;
}

export async function updateMensagemService(id, data) {
    const res = await api.put(`/mensagens/${id}`, data);
    return res.data;
}

export async function deleteMensagemService(id) {
    await api.delete(`/mensagens/${id}`);
}

export async function enviarMensagemService(id, data) {
    const res = await api.post(`/mensagens/${id}/enviar`, data);
    return res.data;
}

export async function deleteMensagensEmMassaService(ids) {
    await api.post("/mensagens/excluir-varias", { ids });
}

// Agendamentos
export async function loadAgendamentosService(campanhaId) {
    const res = await api.get(`/agendamentos/${campanhaId}`);
    return res.data;
}

export async function createAgendamentoService(data) {
    const res = await api.post("/agendamentos", data);
    return res.data;
}

export async function deleteAgendamentoService(id) {
    await api.delete(`/agendamentos/${id}`);
}

// Sessões (para selecionar sessão conectada)
export async function loadSessoesService() {
    const res = await api.get("/whatsapp/sessoes");
    return res.data;
}
